/**
 * StringUtil.js
 * Created on 7-okt-2015
 * 
 * 
 * @author Reinier Feijen for Ranj
 **/

/**
 * Replaces all occurence of keys in Object variables with values.
 * Occurences of keys are delimited (default by '%' chars).
 * Example:
 * input: "Hello, my name is %NAME% %SURNAME%."
 * variables: {name:"Hank", surname:"Williams"}
 * return value: "Hello, my name is Hank Williams."
 * @param	input The input string.
 * @param	variables The key/value pairs to be replaced
 * @return
 */
 export function resolveVariablesInString (input, variables) {
    var openChar = "%", closeChar = "%";
    var res = input;
    for (var s in variables) {
        res = res.split(openChar + s + closeChar).join(variables[s]);
    }
    return res;
}

export function capitalize (str) {
    return str.charAt(0).toUpperCase() + str.substr(1);
}

/**
 * Method checks if email address is syntactically valid.
 * From Senocular: http://www.kirupa.com/forum/showthread.php?p=1914673
 * @param	email Email address to validate.
 * @return Boolean indication validity of email address
 */
export function isValidEmail (email) {
    var emailExpression = /^[a-z][\w.-]+@\w[\w.-]+\.[\w.-]*[a-z][a-z]$/i;
    return emailExpression.test(email);
}

/**
 * Trims all leading and trailing whitespace
 * @param	str Input string
 * @return String without leading and trailing whitespace
 */
export function trim (str) {
    return str.replace(/^\s+|\s+$/g, "");
}

/**
 * Truncates the string and adds a suffix
 * @param	str Input string
 * @param	length Max length of the string
 * @param	suffix Optional suffix to place at the on of the truncated string, defaults to an ellipsis
 * @return Truncated string with a suffix if the length of the string is longer than the given length
 */
export function truncate (str, length, suffix) {
    suffix = suffix === undefined ? "..." : suffix;
    if (str.length > length) {
        return str.substring(0, length) + suffix;
    }
    return str;
}

/**
 * Adds padding to the left of a string
 * @param	str Input string
 * @param	pad Padding (e.g. '0')
 * @param	length Max string length, overflow will be cut off from the right
 * @return  string with provided padding and truncated to match given length
 */
export function padLeft (str, pad, length) {
    return (new Array(length + 1).join(pad) + str).slice(-length);
}

/**
 * Transforms camel-case string into capitalized, space-separated string.
 * E.g.: "thisCamelCase" => "This Camel Case"
 * @param {String} str 
 * @returns {String}
 */
export function camelCaseToSpaces (str) {
    return str
        // insert a space before all caps
        .replace(/([A-Z])/g, ' $1')
        // uppercase the first character
        .replace(/^./, function(str) { return str.toUpperCase(); })
}